export default "__VITE_ASSET__C4ZL9w6k__"